import React, { useCallback, useContext, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { FaEdit } from "react-icons/fa";
import ClickOutHandler from "react-clickout-handler";
import { UserContext } from "../../../../Context/UserContext";

import {
  DocumentArrowDownIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { BaseURL } from "../../../../Reusable/BaseURL";
import { debounce } from "lodash";

export default function NRGPsearch({
  editHandler,
  deleteHandler,
  mergeDataArr,
  setMergeDataArr,
}) {
  const { darkTheme, loginData } = useContext(UserContext);
  const [inpValue, setInpValue] = useState("");
  const [record, setRecord] = useState([]);
  const [loading, setLoading] = useState(false);
  function inpHandler(e) {
    setInpValue(e.target.value);
  }

  const SearchFun = async (query) => {
    setLoading(true);
    const res = await fetch(`${BaseURL}/purchase/nrgp/searchstock?q=${query}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    });
    const data = await res.json();
    if (data.status) {
      setLoading(false);
      const originalData = data.data.data;
      setRecord(originalData);
    } else {
      setLoading(false);
    }
    setLoading(false);
  };

  const debouncedFetchResults = useCallback(
    debounce((value) => {
      SearchFun(value);
    }, 500),
    []
  ); // 500 ms delay

  //   const getSearchData = debounce(SearchFun(inpValue), 400);

  const mergeDataArrFun = (obj, actualAvlQty) => {
    setMergeDataArr([...mergeDataArr, {...obj, actualAvlQty}]);
    setInpValue("");
    setRecord([]);
  };

  return (
    <ClickOutHandler onClickOut={() => setInpValue("")}>
      <div className="px-2">
        <div
          className={
            "flex items-center rounded-lg px-3 pl-4 border-2 border-pink-300 mt-2 w-full md:w-96 " +
            (darkTheme ? "bg-black" : "bg-[#fff]")
          }
        >
          <CiSearch className="w-5 h-5" />
          <input
            type="text"
            // autoFocus={true}
            placeholder="Search .."
            className={
              darkTheme ? "bg-black" : "bg-[#fff] w-full outline-none py-1.5"
            }
            value={inpValue}
            onChange={(e) => {
              inpHandler(e);
              debouncedFetchResults(e.target.value);
            }}
          />
        </div>
        <div
          className={
            "p-2 mt-1.5 rounded-lg my-7 absolute z-40 left-2 right-2 shadow-lg border " +
            `${inpValue === "" ? "hidden" : "block"} || ${
              darkTheme
                ? "bg-gray-700 border-gray-500"
                : "bg-gray-300 border-gray-400 mx-2"
            }`
          }
        >
          <>
            {!loading ? (
              <>
                {record.length > 0 ? (
                  record
                    //   .filter((item) => {
                    //     const searchValue = inpValue.toLowerCase();
                    //     const name = item.item_name.toLowerCase() || item.hsn_no || item.item_code;
                    //     return name && name.startsWith(searchValue);
                    //   })
                    .map((item, index) => (
                      <div
                        key={index}
                        className={
                          "nthChildBorder px-2 hover:rounded-lg cursor-pointer border-b border-b-[#dbb] rounded-lg " +
                          `${inpValue === "" ? "hidden" : "block"} ||
                ${
                  darkTheme
                    ? "hover:bg-gray-600 hover:border-none"
                    : "hover:bg-[#dbb]"
                }`
                        }
                        onClick={() => mergeDataArrFun(item, item.avl_qty)}
                      >
                        <div className="flex items-center gap-2 flex-wrap py-1.5">
                          <div className="flex gap-2 flex-grow flex-wrap">
                            <div
                              className={
                                "font-[500] px-2 rounded-lg mr-1 " +
                                (darkTheme ? "bg-gray-800" : "bg-gray-200")
                              }
                            >
                              {item.item_name}
                            </div>
                            <div className="bg-blue-200 px-0.5 rounded">
                              HSN No: {item.hsn_no}
                            </div>
                            <div className="bg-blue-200 px-0.5 rounded">
                              ItemCode: {item.hsn_no}
                            </div>
                            <div className="bg-blue-200 px-0.5 rounded">
                              Qty: {item.qty}
                            </div>
                            <div className="bg-blue-200 px-0.5 rounded">
                              {" "}
                              Avl-Qty: {item.avl_qty}
                            </div>
                          </div>
                          <div>
                            {/* <button
                              onClick={() => editHandler(item._id)}
                              className={
                                "mr-3 rounded-full p-2 transition-all " +
                                (darkTheme
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-300")
                              }
                            >
                              <FaEdit className="w-5 h-5" />
                            </button> */}
                            {/* <button
                              onClick={() => deleteHandler(item._id)}
                              className={
                                "rounded-full p-2 transition-all " +
                                (darkTheme
                                  ? "hover:bg-gray-700"
                                  : "hover:bg-gray-300")
                              }
                            >
                              <TrashIcon className="w-5 h-5" />
                            </button> */}
                          </div>
                        </div>
                      </div>
                    ))
                ) : (
                  <span className="text-red-600 px-3">Not Matched</span>
                )}
              </>
            ) : (
              <span className="px-3">Loading..</span>
            )}
          </>
        </div>
      </div>
    </ClickOutHandler>
  );
}
